export default "__VITE_ASSET__BarGf8Q1__"